module.exports = __webpack_public_path__ + "static/media/readyToChat.98d8eaef.png";